import React, { Component, PureComponent, Fragment } from 'react'
import { Button, Dropdown, Table, Icon, Checkbox, Dimmer, Loader, Message, Popup, Form } from 'semantic-ui-react'
import { SimpleForm } from '~/form'
import { Map, List, fromJS } from 'immutable'
import Api from '~/api'
import moment from 'moment'
import { connect } from 'react-redux'
import { generateWidgetCodeForEmail } from './widgetCode'

class SendMessage extends Component {
  state = {
    open: false,
    success: false,
  }

  renderForm = () => {
    let { open } = this.state
    if (!open) return null

    let { organization, contacts, sendMessage } = this.props

    let formFields = [
      {
        name: 'templates',
        type: 'checkboxes',
        label: 'Viestipohja',
        options: [
          { value: 'vuosisopimuksen_tilausvahvistus', label: 'Vuosisopimuksen tilausvahvistus' },
          { value: 'nps_ohjeet', label: 'Ohjeet NPS:n käyttöön' },
        ],
      },
      {
        name: 'contacts',
        type: 'checkboxes',
        label: 'Vastanaottajat',
        options: contacts.map(c => ({ value: c.get('id'), label: c.get('email') })).toJS(),
      },
      {
        name: 'message',
        type: 'textarea',
        label: 'Oma viesti',
      },
      {
        name: 'cc_me',
        type: 'checkbox',
        inputLabel: 'Lähetä kopio itselle',
      },
    ]

    return (
      <SimpleForm
        fields={formFields}
        values={Map({ cc_me: true })}
        validation={{ templates: ['required'], contacts: ['required'] }}
        submitText="Lähetä viesti"
        prompt
        onSubmit={values =>
          sendMessage(values).then(res => {
            if (res.success) setTimeout(() => this.setState({ open: false }), 1)

            return res
          })
        }
      />
    )
  }

  render() {
    let { open } = this.state

    return (
      <Popup
        trigger={
          <button className="button-plain" onClick={e => e.preventDefault()}>
            + Lähetä sähköpostiviesti
          </button>
        }
        content={this.renderForm()}
        style={{ margin: 0, padding: 0, borderRadius: 0 }}
        on="click"
        open={open}
        onOpen={() => this.setState({ open: true })}
        onClose={() => this.setState({ open: false })}
        position="bottom left"
      />
    )
  }
}

class OrganizationMessages extends Component {
  state = {
    loading: false,
    messages: List(),
  }

  componentDidMount() {
    let { organization } = this.props

    this.setState({
      loading: true,
    })

    Api.get('/message', { organization_id: organization.get('id') })
      .then(({ data }) => {
        let stateUpdate = {
          loading: false,
        }

        if (data.success) stateUpdate.messages = fromJS(data.messages || [])
        else stateUpdate.error = data.message || 'Problem when getting messages'

        this.setState(stateUpdate)
      })
      .catch(err => {
        console.log(err)
        this.setState({
          loading: false,
          error: err.message || 'Problem when getting messages',
        })
      })
  }

  sendMessage = message => {
    let { organization, surveys, contacts, plans } = this.props

    message = message.toJS()

    let replacements = {
      widget_code: generateWidgetCodeForEmail(organization.get('businessid', '')),
      message: message.message || '',
    }

    let slug = organization.getIn(['data', 'slug'], false)

    /* Set surveys info */
    replacements.surveys = surveys
      .map(s => {
        let url = `${window.NPS_URL}${slug ? '/' + slug : ''}/${s.get('id')}`
        return `<div>${s.get('name')}</div><div><a href="${url}">${url}</a></div>`
      })
      .join('<div>&nbsp;</div>')

    /* Add organization info */
    replacements.asiakkaan_nimi = organization.get('name')
    replacements.asiakkaan_osoite = organization.getIn(['data', 'address'])

    /* Add contact person info */

    let contact = contacts.find(c => c.getIn(['data', 'role']) === 'contract')

    if (Map.isMap(contact)) {
      replacements.asiakkaan_yhteyshenkilo = contact.get('name')
      replacements.asiakkaan_yhteyshenkilo_sahkoposti = contact.get('email')
    }

    /* Add subscription info */
    let subscription = organization.getIn(['subscriptions', 0], Map())
    let plan = plans.find(p => p.get('id') === subscription.get('plan_id'))
    if (!Map.isMap(plan)) plan = Map()

    replacements.palvelu_nimi = plan.getIn(['data', 'invoiceName'], plan.get('name'))

    let price = parseInt(subscription.getIn(['data', 'price'], 0))
    let discount = parseInt(subscription.getIn(['data', 'discount'], 0))
    replacements.palvelu_hinta = discount
      ? `${price}€ - ${discount}% = ${price - (discount / 100) * price}€`
      : `${price} €`
    replacements.sopimus_alkaa = moment(subscription.get('created_at')).format('DD.MM.YYYY')

    let kokeilujakso_info_text = 'Sopimus alkaa 3kk kokeilujaksolla.'

    replacements.kokeilujakso_info = subscription.get('status') === 'trial' ? kokeilujakso_info_text : ''

    delete message.message
    message.replacements = replacements

    if (message.template === 'nps_ohjeet') message.includeNpsReplacement = true

    return Api.post('/message', message, { organization_id: organization.get('id') })
      .then(({ data }) => {
        if (data.success) {
          let { messages } = this.state
          this.setState({
            messages: messages.concat(fromJS(data.messages || [])),
          })
        }
        console.log(data)

        return data
      })
      .catch(err => {
        console.log(err)
        return {
          success: false,
        }
      })
  }

  render() {
    let { organization, contacts, plans } = this.props
    let { loading, messages } = this.state

    return (
      <div className="messages">
        <Table selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell content="Otsikko" />
              <Table.HeaderCell content="Vastaanottaja" />
              <Table.HeaderCell content="Lähetetty" />
              <Table.HeaderCell content="Status" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {loading ? (
              <Table.Row>
                <Table.Cell colSpan="5" className="table-empty-text">
                  Ladataan viestejä...
                </Table.Cell>
              </Table.Row>
            ) : messages.size ? (
              messages.map(message => {
                let id = message.get('id')

                return (
                  <Table.Row key={id}>
                    <Table.Cell>{message.getIn(['data', 'subject'])}</Table.Cell>
                    <Table.Cell>{message.getIn(['data', 'to'])}</Table.Cell>
                    <Table.Cell>{moment(message.get('created_at')).format('DD.MM.YYYY - HH:ss')}</Table.Cell>
                    <Table.Cell>{message.getIn(['data', 'status'])}</Table.Cell>
                  </Table.Row>
                )
              })
            ) : (
              <Table.Row>
                <Table.Cell colSpan="5" className="table-empty-text">
                  Viestejä ei ole lähetetty.
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="5" textAlign="left">
                <div className="organization-message-add-wrapper">
                  <div className="organization-message-add-button">
                    <SendMessage {...this.props} sendMessage={this.sendMessage} />
                  </div>
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    contacts: state.contacts || List(),
    plans: state.plans || List(),
    contactsLoading: state.contactsLoading,
    contactsError: state.contactsError,
  }
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationMessages)
